import React, { useRef, useState } from "react";
import Image from "@tiptap/extension-image";
import async from "async";
import Compressor from "compressorjs";

import { uploadImage } from "../../utils/upload";

export const CustomImage = Image.extend({
  addAttributes() {
    return {
      src: {
        default: null,
      },
      alt: {
        default: null,
      },
      title: {
        default: null,
      },
      class: {
        default: "tipTap-image",
      },
      "data-base64": {
        default: null,
      },
      "data-label": {
        default: null,
      },
    };
  },
});

export const AddImage = ({ editor, className }) => {
  const imageRef = useRef();
  const [imageUrl, setImageUrl] = useState();

  if (!editor) {
    return <></>;
  }

  const fileChangeHandler = (e) => {
    const file = e.target.files[0];
    console.log(file);

    async.parallel(
      {
        image(callback) {
          new Compressor(file, {
            quality: 0.6,
            convertSize: 100000,
            mimeType: "auto",
            success: (result) => {
              setImageUrl(URL.createObjectURL(result));
              uploadImage(result, (event) => {
                const percentComplete = Math.round((100 * event.loaded) / event.total);
              })
                .then((res) => {
                  //   setImageUrl(res.data.link);
                  editor.commands.insertContent({
                    type: "image",
                    attrs: {
                      src: res.data.link,
                      alt: "altText",
                      title: file.name,
                      class: className || "tipTap-image-center",
                      "data-base64": file,
                      "data-label": "imageTitle",
                    },
                  });
                  editor.chain().focus().run();

                  callback(null, res.data.link);
                })
                .catch(() => {
                  callback("error image");
                })
                .finally(() => {});
            },
            error: (err) => {
              callback("error image");
            },
          });
        },
      },
      (err, results) => {
        if (err) {
          console.log(err);
          toast.error("Không đăng tải được ảnh", TOASTIFY_OPTIONS);
          imageRef.current.value = "";
          setImageUrl("");
          return;
        }
      },
    );
  };

  return (
    <>
      <button
        onClick={() => imageRef.current.click()}
        //   className={editor.isActive("blockquote") ? "is_active" : ""}
      >
        <i className="fa-light fa-image fa-lg" />
      </button>

      <input
        ref={imageRef}
        type="file"
        accept="image/*"
        className="d-none"
        onChange={fileChangeHandler}
      />
    </>
  );
};
